import styled from "styled-components";

export const Container = styled.div`
  /*padding: 10px;*/
  background: #f5f5f5;
`;
